<template>
  <div
    class="p-index"
    :style="[clickPointStyles, isHoverItems.indexOf(index) > -1 ? clickPointHoverStyles : {}]"
    @mouseover="mouseOverProduct"
    @mouseout="mouseOutProduct"
    :data-index="index"
  >
    <template v-if="isClickIconUseIcon">
      <span v-html="clickIconIconText"></span>
    </template>
    <template v-else>{{index}}</template>
  </div>
</template>

<script>
export default {
  name: "ClickIcon",
  props: ["index", "product", "isHoverItems"],
  computed: {
    isClickIconUseIcon: function() {
      return this.$store.state.front.settings.clickIconUseIcon != ""
        ? true
        : false;
    },
    clickIconIconText: function() {
      return (
        '<i class="' +
        this.$store.state.front.settings.clickIconIconText +
        '"></i>'
      );
    },
    clickPointStyles: function(index) {
      let styles = {
        width: this.$store.state.front.settings.clickIconWidth + "px",
        height: this.$store.state.front.settings.clickIconWidth + "px",
        lineHeight: this.$store.state.front.settings.clickIconWidth + "px",
        fontSize: this.$store.state.front.settings.clickIconFontSize + "px",
        backgroundColor: this.$store.state.front.settings.clickIconBackground,
        color: this.$store.state.front.settings.clickIconTextColor
      };

      return styles;
    },
    clickPointHoverStyles: function(index) {
      let styles = {
        backgroundColor: this.$store.state.front.settings
          .clickIconHoverBackground,
        color: this.$store.state.front.settings.clickIconHoverTextColor
      };

      return styles;
    }
  },
  methods: {
    mouseOverProduct: function(event) {
      let index = parseInt(jQuery(event.target).attr("data-index"));
  
      if (this.isHoverItems.indexOf(index) < 0) {
        this.isHoverItems.push(index); // = [...this.actives, index];
      }
    },
    mouseOutProduct: function(event) {
      let index = parseInt(jQuery(event.target).attr("data-index"));

      if (this.isHoverItems.indexOf(index) > -1) {
        this.isHoverItems.splice(this.isHoverItems.indexOf(index), 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.p-index {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
</style>